import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';

export namespace NICmsOutletBlockComponent {
    export const BLOCK_ID = 'icms-outlet-block-component';

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export interface IBlockDataContent {
        components: NICmsContentComponent.IData[];
    }
}

@Component({
    selector: 'icms-outlet-block',
    templateUrl: 'icms-outlet-block.html',
    styleUrl: 'icms-outlet-block.scss',
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ICmsOutletBlockComponent>({
    id: NICmsOutletBlockComponent.BLOCK_ID,
    block: {
        url: NICmsOutletBlockComponent.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Outlet',
    description: 'Outlet block',
    fields: [
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'component',
            default: []
        }
    ]
})
export class ICmsOutletBlockComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NICmsOutletBlockComponent.IBlockDataContent;

    @Input()
    variant?: string | NICmsContentComponent.TVariant;

    @Input()
    name?: string;

    @Input()
    allow?: string[];

    /**
     * Components identifieres list, restricts the list to these components only
     */
    @Input()
    allowOnly?: string[];

    @Input()
    disallow?: string[];

    @Input()
    outletOptions?: NICmsContentComponent.IOutletOptions;
}
